"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { CreateWaveDatesConfig, CreateWaveOutcomeConfig, CreateWaveOutcomeType } from "@/types/waves.types";
import RepCategorySearch from "@/components/utils/input/rep-category/RepCategorySearch";
import { ApiWaveType } from "@/generated/models/ApiWaveType";
import CreateWaveOutcomeWarning from "../CreateWaveOutcomeWarning";
import PrimaryButton from "@/components/utils/button/PrimaryButton";
export default function CreateWaveOutcomesRepApprove(t0) {
  const $ = _c(58);
  const {
    waveType,
    dates,
    onOutcome,
    onCancel
  } = t0;
  const outcomeType = CreateWaveOutcomeType.REP;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      type: outcomeType,
      title: null,
      credit: null,
      category: null,
      winnersConfig: null,
      maxWinners: null
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [outcome, setOutcome] = useState(t1);
  const [categoryError, setCategoryError] = useState(false);
  const [creditError, setCreditError] = useState(false);
  let t2;
  if ($[1] !== outcome) {
    t2 = category => {
      setCategoryError(false);
      setOutcome({
        ...outcome,
        category
      });
    };
    $[1] = outcome;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const setCategory = t2;
  let t3;
  if ($[3] !== outcome) {
    t3 = e => {
      const newCredit = parseFloat(e.target.value);
      const isValid = !isNaN(newCredit) && newCredit >= 0;
      setOutcome({
        ...outcome,
        credit: isValid ? newCredit : null
      });
      setCreditError(false);
    };
    $[3] = outcome;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const setCredit = t3;
  let t4;
  if ($[5] !== outcome) {
    t4 = e_0 => {
      const newMaxWinners = parseInt(e_0.target.value);
      const isValid_0 = !isNaN(newMaxWinners) && newMaxWinners > 0;
      setOutcome({
        ...outcome,
        maxWinners: isValid_0 ? newMaxWinners : null
      });
    };
    $[5] = outcome;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const setMaxWinners = t4;
  let t5;
  if ($[7] !== onOutcome || $[8] !== outcome) {
    t5 = () => {
      const dontHaveCategorySet = !outcome.category;
      const dontHaveCreditSet = !outcome.credit;
      setCategoryError(dontHaveCategorySet);
      setCreditError(dontHaveCreditSet);
      if (dontHaveCategorySet || dontHaveCreditSet) {
        return;
      }
      onOutcome(outcome);
    };
    $[7] = onOutcome;
    $[8] = outcome;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const onSubmit = t5;
  let t6;
  if ($[10] !== categoryError || $[11] !== outcome.category || $[12] !== setCategory) {
    t6 = <div className="tw-flex tw-flex-col sm:tw-flex-row tw-gap-4 tw-w-full tw-pt-[0.5px]"><RepCategorySearch error={categoryError} category={outcome.category} setCategory={setCategory} /></div>;
    $[10] = categoryError;
    $[11] = outcome.category;
    $[12] = setCategory;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== outcome.credit) {
    t7 = outcome.credit !== null ? outcome.credit.toString() : "";
    $[14] = outcome.credit;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const t8 = `${creditError ? "tw-ring-error focus:tw-border-error focus:tw-ring-error tw-caret-error" : "tw-ring-iron-650 focus:tw-border-blue-500 focus:tw-ring-primary-400 tw-caret-primary-400"} ${outcome.credit ? "focus:tw-text-white tw-text-primary-400" : "tw-text-white"}  tw-form-input tw-block tw-px-4 tw-pt-4 tw-pb-3 tw-w-full tw-text-base tw-rounded-lg tw-border-0 tw-appearance-none tw-border-iron-600 tw-peer tw-bg-iron-900 focus:tw-bg-iron-900 tw-font-medium tw-shadow-sm tw-ring-1 tw-ring-inset placeholder:tw-text-iron-500 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset tw-transition tw-duration-300 tw-ease-out`;
  let t9;
  if ($[16] !== setCredit || $[17] !== t7 || $[18] !== t8) {
    t9 = <input type="text" value={t7} onChange={setCredit} id="outcome-rep-credit" autoComplete="off" className={t8} placeholder=" " />;
    $[16] = setCredit;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const t10 = `${creditError ? "peer-focus:tw-text-error" : "peer-focus:tw-text-primary-400"} tw-text-iron-500 tw-absolute tw-cursor-text tw-text-base tw-font-normal tw-duration-300 tw-transform -tw-translate-y-4 tw-scale-75 tw-top-2  tw-origin-[0] tw-bg-iron-900 peer-focus:tw-bg-iron-900 tw-px-2 peer-focus:tw-px-2  peer-placeholder-shown:tw-scale-100 
              peer-placeholder-shown:-tw-translate-y-1/2 peer-placeholder-shown:tw-top-1/2 peer-focus:tw-top-2 peer-focus:tw-scale-75 peer-focus:-tw-translate-y-4 rtl:peer-focus:tw-translate-x-1/4 rtl:peer-focus:tw-left-auto tw-start-1`;
  let t11;
  if ($[20] !== t10) {
    t11 = <label htmlFor="outcome-rep-credit" className={t10}>Rep</label>;
    $[20] = t10;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t9) {
    t12 = <div className="tw-group tw-w-full tw-relative">{t9}{t11}</div>;
    $[22] = t11;
    $[23] = t9;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== creditError) {
    t13 = creditError && <div className="tw-pt-1.5 tw-flex tw-items-center tw-gap-x-2"><svg className="tw-size-5 tw-flex-shrink-0 tw-text-error" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg><div className="tw-text-error tw-text-xs tw-font-medium">Rep must be a positive number</div></div>;
    $[25] = creditError;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t12 || $[28] !== t13) {
    t14 = <div>{t12}{t13}</div>;
    $[27] = t12;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== outcome.maxWinners) {
    t15 = outcome.maxWinners !== null ? outcome.maxWinners.toString() : "";
    $[30] = outcome.maxWinners;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  const t16 = ` ${outcome.maxWinners ? "focus:tw-text-white tw-text-primary-400" : "tw-text-white"} tw-ring-iron-650 focus:tw-border-blue-500 focus:tw-ring-primary-400 tw-caret-primary-400 tw-form-input tw-block tw-px-4 tw-pt-4 tw-pb-3 tw-w-full tw-text-base tw-rounded-lg tw-border-0 tw-appearance-none tw-border-iron-600 tw-peer tw-bg-iron-900 focus:tw-bg-iron-900 tw-font-medium tw-shadow-sm tw-ring-1 tw-ring-inset placeholder:tw-text-iron-500 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset tw-transition tw-duration-300 tw-ease-out`;
  let t17;
  if ($[32] !== setMaxWinners || $[33] !== t15 || $[34] !== t16) {
    t17 = <input type="text" value={t15} onChange={setMaxWinners} id="outcome-rep-max-winners" autoComplete="off" className={t16} placeholder=" " />;
    $[32] = setMaxWinners;
    $[33] = t15;
    $[34] = t16;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <label htmlFor="outcome-rep-max-winners" className={"peer-focus:tw-text-primary-400 tw-text-iron-500  tw-absolute tw-cursor-text tw-text-base tw-font-normal tw-duration-300 tw-transform -tw-translate-y-4 tw-scale-75 tw-top-2 tw-origin-[0] tw-bg-iron-900 peer-focus:tw-bg-iron-900 tw-px-2 peer-focus:tw-px-2  peer-placeholder-shown:tw-scale-100 \n              peer-placeholder-shown:-tw-translate-y-1/2 peer-placeholder-shown:tw-top-1/2 peer-focus:tw-top-2 peer-focus:tw-scale-75 peer-focus:-tw-translate-y-4 rtl:peer-focus:tw-translate-x-1/4 rtl:peer-focus:tw-left-auto tw-start-1"}>Max Winners</label>;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== t17) {
    t19 = <div><div className="tw-group tw-w-full tw-relative">{t17}{t18}</div></div>;
    $[37] = t17;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== t14 || $[40] !== t19) {
    t20 = <div className="tw-grid md:tw-grid-cols-2 tw-gap-x-5">{t14}{t19}</div>;
    $[39] = t14;
    $[40] = t19;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== dates || $[43] !== outcome.maxWinners || $[44] !== waveType) {
    t21 = <CreateWaveOutcomeWarning waveType={waveType} dates={dates} maxWinners={outcome.maxWinners} />;
    $[42] = dates;
    $[43] = outcome.maxWinners;
    $[44] = waveType;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] !== onCancel) {
    t22 = <button onClick={onCancel} type="button" className="tw-bg-iron-800 tw-border-iron-700 tw-text-iron-300 hover:tw-bg-iron-700 hover:tw-border-iron-700 tw-relative tw-inline-flex tw-items-center tw-justify-center tw-px-4 tw-py-3 tw-text-sm tw-font-semibold tw-border tw-border-solid tw-rounded-lg tw-transition tw-duration-300 tw-ease-out">Cancel</button>;
    $[46] = onCancel;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  let t23;
  if ($[48] !== onSubmit) {
    t23 = <PrimaryButton onClicked={onSubmit} disabled={false} loading={false} padding="tw-px-4 tw-py-3">Save</PrimaryButton>;
    $[48] = onSubmit;
    $[49] = t23;
  } else {
    t23 = $[49];
  }
  let t24;
  if ($[50] !== t22 || $[51] !== t23) {
    t24 = <div className="tw-flex tw-justify-end tw-gap-x-3">{t22}{t23}</div>;
    $[50] = t22;
    $[51] = t23;
    $[52] = t24;
  } else {
    t24 = $[52];
  }
  let t25;
  if ($[53] !== t20 || $[54] !== t21 || $[55] !== t24 || $[56] !== t6) {
    t25 = <div className="tw-col-span-full"><div className="tw-flex tw-flex-col tw-gap-y-5">{t6}{t20}{t21}{t24}</div></div>;
    $[53] = t20;
    $[54] = t21;
    $[55] = t24;
    $[56] = t6;
    $[57] = t25;
  } else {
    t25 = $[57];
  }
  return t25;
}